import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Tooltip,
    IconButton,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SendIcon from '@mui/icons-material/Send';
import { Delete } from '@mui/icons-material';
import { getImageSource } from '../apiRewards/routes';
import { messageShow } from '../../common/api/actions';
import { remove, publishToggle } from "../api/actions/mutation";
import dayjs from 'dayjs';

class GoalCard extends Component {

    onDeleteGoal = async () => {
        const { goal, remove, refresh, messageShow } = this.props;
        const confirmDelete = window.confirm("Are you sure you want to delete this goal?");
        if (!confirmDelete) return;

        try {
            const removedData = await remove({ goalIds: [goal._id] });

            if (removedData.some(res => res.success)) {
                messageShow("Goal deleted successfully.");
                refresh();
            } else {
                messageShow("Failed to delete the goal.");
            }
        } catch (error) {
            messageShow("An error occurred while deleting the Goal.");
            console.error("Error deleting Goal: ", error)
        }
    };

    onPublishToggle = goalId => async event => {
        const isPublished = event.target.checked
        let check = window.confirm(`Are you sure you want to ${isPublished ? 'publish' : 'unpublish'} this goal?`)

        if (check) {
           const { publishToggle, messageShow, refresh } = this.props

           try {
              const { data } = await publishToggle({ goalId, isPublished })
               
               if (data.success) {
                messageShow(data.message)
                refresh();
               }
            } catch (error) {
               console.error(`Error ${isPublished ? 'publishing' : 'unpublishing'} goal: `, error)
                messageShow('Some error occurred. Please try again.')
            }
        }
    }

    render() {
        const { goal, permissions, onClone, onOpenMessagingDialog } = this.props;
        const isExpired = goal.isExpired;

        return (
            <Card sx={{ maxWidth: 400, m: 1, cursor: permissions.canEdit ? 'pointer' : 'default' }} onClick={() => permissions.canEdit && this.props.history.push(`/goals/edit/${goal._id}`)}>
                <CardMedia
                    component="img"
                    loading='lazy'
                    height="160"
                    image={getImageSource(goal.image)}
                    alt={goal.goalName}
                    onError={(e) => {
                        e.target.src = getImageSource();
                    }}
                />
                <CardContent>
                    <Tooltip title={goal.goalName} arrow>
                        <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            sx={{
                                width: '100%',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'block',
                            }}
                        >
                            {goal.goalName}
                        </Typography>
                    </Tooltip>
                    <Typography variant="body2" color="text.secondary">
                        Reward Points: {goal.rewardPoints}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Min Order:
                        {goal.minOrderValue || 0}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Expiry Date: {dayjs(goal.expiryDate).format("DD-MM-YYYY")}
                    </Typography>
                </CardContent>
                <CardContent>
                    <Tooltip title="Delete">
                        <IconButton
                            disabled={isExpired || !permissions.canDelete}
                            color="error"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onDeleteGoal();
                            }}
                        >
                            <Delete />
                        </IconButton>
                    </Tooltip>
                    <FormControlLabel
                       control={
                        <Checkbox
                          checked={goal.isPublished}
                          onChange={this.onPublishToggle(goal._id)}
                          onClick={(e) => e.stopPropagation()}
                          disabled={!permissions.canEdit}
                          sx={{ ml: 1}}
                        />
                        }
                        label="Published"
                    />
                    <Tooltip title="Create Notification" arrow>
                        <span>
                            <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onOpenMessagingDialog(goal._id);
                                }}
                                color="primary"
                                disabled={isExpired || !permissions.canEdit}
                            >
                                <SendIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Clone" arrow>
                        <span>
                            <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onClone(goal);
                                }}
                                color="primary"
                                disabled={!permissions.canEdit}
                            >
                                <FileCopyIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                </CardContent>
            </Card>
        );
    }
}

const mapDispatchToProps = {
    messageShow,
    remove,
    publishToggle,
};

export default withRouter(connect(null, mapDispatchToProps)(GoalCard));

